/**
 * Sprint 30 M4 — Hold Creation lens.
 *
 * Thin filtered view over the canonical Policy Library. Same row component,
 * same detail page, same Create Policy affordance as /app/policies. The
 * manual rule builder lives behind an explicit "Advanced editor" affordance.
 */
import { createFileRoute, Link } from "@tanstack/react-router";
import { Wrench } from "lucide-react";

import { Button } from "@/components/ui/button";
import { PolicyLibraryView } from "@/components/policy-library/policy-library-view";

export const Route = createFileRoute("/_authenticated/app/admin/hold-creation")({
  component: HoldCreationLens,
});

function HoldCreationLens() {
  return (
    <PolicyLibraryView
      lockedCapability="hold_creation"
      title="Hold Creation Policies"
      description="Policies that decide when to place orders on hold at import. Filtered view of the Policy Library."
      extraActions={
        <Button asChild size="sm" variant="ghost">
          <Link to="/app/admin/hold-creation/advanced">
            <Wrench className="h-3.5 w-3.5 mr-1.5" />
            Manual editor
          </Link>
        </Button>
      }
    />
  );
}
